import { MAX_SESSION_TIME_MS, MAX_STACK_TRACE_SIZE_BYTES } from '../constants';
export const sanitizePayload = payload => {
  const {
    errorStack,
    sessionTime
  } = payload;
  if (errorStack && errorStack.length > MAX_STACK_TRACE_SIZE_BYTES) {
    const truncationMessage = `...[truncated by Panorama client to ${MAX_STACK_TRACE_SIZE_BYTES / 1024}kb]`;
    const truncatedErrorStack = errorStack.substring(0, MAX_STACK_TRACE_SIZE_BYTES - truncationMessage.length);
    payload = {
      ...payload,
      errorStack: `${truncatedErrorStack}${truncationMessage}`
    };
  }
  if (sessionTime && sessionTime > MAX_SESSION_TIME_MS) {
    payload = {
      ...payload,
      sessionTime: MAX_SESSION_TIME_MS
    };
  }
  return payload;
};
//# sourceMappingURL=payload-sanitizer.js.map